import Mainpage from "./Components/MainPage/MainPage.component";

function App() {
  return (
    <div className="App">
      <Mainpage />  
      {/* <PopUp /> */}
    </div>
  );
}

export default App;
